// @ts-nocheck
import React from 'react';
import { FileText, ImageIcon } from 'lucide-react';

interface Props {
  url?: string | null;
  className?: string;
}

/**
 * Renders a "View score sheet" link for a completed game's stored score-sheet
 * file. Shows a small thumbnail when the stored file is an image; a document
 * icon when it's a PDF. Renders nothing when no file is stored.
 */
const ScoreSheetImageLink: React.FC<Props> = ({ url, className }) => {
  if (!url) return null;
  const isPdf = /\.pdf(\?|$)/i.test(url);
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground underline-offset-2 hover:text-foreground hover:underline ${className || ''}`}
      title="View stored score sheet"
    >
      {isPdf ? (
        <FileText className="h-4 w-4 shrink-0" />
      ) : (
        <img
          src={url}
          alt="Score sheet"
          loading="lazy"
          className="h-8 w-8 shrink-0 rounded border object-cover"
        />
      )}
      View score sheet
    </a>
  );
};

export default ScoreSheetImageLink;
